import React from 'react';
const steps = [{
  num: 1,
  text: 'Abres los tomos'
}, {
  num: 2,
  text: 'Revisas la información'
}, {
  num: 3,
  text: 'Lo aplicas y ves los resultados'
}];
export function Guarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-156">
      <div className="max-w-xl mx-auto" data-id="element-157">
        <div className="bg-gray-900 border border-green-600/40 rounded-2xl p-6 md:p-8" data-id="element-158">
          {/* Headline */}
          <h2 className="text-xl md:text-2xl font-black text-white text-center mb-6" data-id="element-159">
            🛡️ Garantía 7 días sin preguntas
          </h2>

          {/* Steps */}
          <div className="space-y-3 mb-6" data-id="element-160">
            {steps.map(step => <div key={step.num} className="flex items-center gap-4 bg-gray-800/60 border border-gray-700/50 rounded-lg px-4 py-3" data-id="element-161">
                <div className="bg-gray-700 text-white text-xs font-black w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" data-id="element-162">
                  {step.num}
                </div>
                <span className="text-sm font-medium text-gray-300" data-id="element-163">
                  {step.text}
                </span>
              </div>)}
          </div>

          {/* Refund box */}
          <div className="bg-green-950/40 border border-green-600/30 rounded-xl p-5 text-center" data-id="element-164">
            <p className="text-sm text-gray-400 mb-2" data-id="element-165">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-xl md:text-2xl font-black text-green-400 mb-1" data-id="element-166">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-xs text-gray-500" data-id="element-167">Sin preguntas. Sin vueltas.</p>
          </div>
        </div>
      </div>
    </section>;
}